export { default as FullCycleTableRow } from './component';
